'use strict';

const swiperGeneralNew = new Swiper('#general-new', {
    spaceBetween: 15,
    effect: 'fade',
    loop: false,
    navigation: {
        nextEl: '.general-new-next',
        prevEl: '.general-new-prev',
    },
});

const swiperNews = new Swiper('#news-container', {
    spaceBetween: 15,
    slidesPerView: 3,
    loop: false,
    navigation: {
        nextEl: '.news-next',
        prevEl: '.news-prev',
    },
    breakpoints: {
        768: {
            slidesPerView: 2,
            spaceBetween: 20,
        },
        640: {
            slidesPerView: 2,
            spaceBetween: 20,
        },
        480: {
            slidesPerView: 1,
            spaceBetween: 10,
        },
    }
});

const swiperGallery = new Swiper('#photos-container', {
    spaceBetween: 15,
    slidesPerView: 3,
    loop: true,
    navigation: {
        nextEl: '.photos-next',
        prevEl: '.photos-prev',
    },
    breakpoints: {
        768: {
            slidesPerView: 2,
            spaceBetween: 20,
        },
        640: {
            slidesPerView: 2,
            spaceBetween: 20,
        },
        480: {
            slidesPerView: 1,
            spaceBetween: 10,
        },
    }
});

const swiperUsefulLinks = new Swiper('#links-container', {
    spaceBetween: 15,
    slidesPerView: 3,
    loop: false,
    autoplay: {
        delay: 5000,
    },
    navigation: {
        nextEl: '.links-next',
        prevEl: '.links-prev',
    },
    breakpoints: {
        768: {
            slidesPerView: 2,
            spaceBetween: 20,
        },
        640: {
            slidesPerView: 2,
            spaceBetween: 20,
        },
        480: {
            slidesPerView: 1,
            spaceBetween: 10,
        },
    }
});
